export default __webpack_public_path__ + "static/media/educators1.7f286be9.jpg";